import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { case_study_helper } from "@/helpers/case_study_helper";
import * as additionalComponents from "./__components";
import { createTitle } from "@/functions/createTitle";

export default function CaseStudyPage({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const page = case_study_helper.find(url_slug);

  return {
    props: {
      meta: {
        title: createTitle(page.title, "Case Studies"),
      },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: "Employers", href: getRoute("employers") },
              { label: "Case Studies", href: getRoute("caseStudies") },
              { label: page.title, href: getRoute("caseStudyPage", { url_slug }) },
            ],
          },
        },
        {
          component: "Header",
          props: {
            title: {
              path: `page.caseStudy.${url_slug}.component.Header.title`,
              placeholder: page.title,
            },
            img: page.cover_image ?? null,
            back: {
              path: "page.caseStudy.component.Header.back",
              placeholder: `Back to Case Studies`,
              href: getRoute("caseStudies"),
            },
          },
        },
        { component: "CaseStudyContent", props: { ...page } },
        { component: "Divider" },
        {
          component: "Form",
          props: {
            className: "py-4 py-md-5 text-center",
            title: {
              path: "page.caseStudy.component.Form.title",
              placeholder: "Are you a healthcare employer interested in our services or workforce solutions?",
            },
            description: {
              path: "page.caseStudy.component.Form.description",
              placeholder:
                "Please complete the form below with a brief description of your staffing requirements and we will be in touch.",
            },
            formId: "a7c90e4b-38ed-43c1-815f-34d1f30a562a",
          },
        },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: case_study_helper.toPaths(),
    fallback: false,
  };
}
